<template>
  <v-flex xs12>
    <v-card>
      <v-flex xs12 px-4 py-3 v-if="err">
        <v-alert :value="true" type="error">{{err}}</v-alert>
      </v-flex>
      <v-flex xs12 px-4 py-3 v-if="success">
        <v-alert :value="true" type="success">{{success}}</v-alert>
      </v-flex>
      <v-form v-model="valid" class="pt-3" >
         <v-layout row wrap class="px-2 pb-2">
          <v-flex xs12 sm6 md4 lg3 px-3>
            <v-autocomplete
              :label="$lang.actions.selectCompany"
              :items="mappedCompanies"
              :loading="companyLoading"
              v-model="data.companyId"
              required
              :rules="[v => !!v || `${$lang.errors.missingCompany}`]"
            />
          </v-flex>
          <v-flex xs12 sm12 md8 lg7 px-4>
            <v-autocomplete
              multiple
              clearable
              :label="$lang.actions.selectResTrackingTypes"
              :items="trackingTypes"
              v-model="data.resourceTrackingTypes"
              item-text="text"
              item-value="value"
              hide-details
            />
          </v-flex>
        </v-layout>
        <v-layout row wrap class="px-2 pb-3">
          <v-flex xs12 sm6 md4 lg3 px-3>
            <v-menu
              ref="menu"
              v-model="menu"
              :return-value.sync="data.fromDate"
              lazy
              transition="scale-transition"
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="data.fromDate"
                :label="$lang.labels.fromDate"
                prepend-icon="event"
                required
                :rules="[v => !!v || `${$lang.errors.missingFromDate}`]"
                readonly
              />
              <v-date-picker color="primary" v-model="data.fromDate" no-title scrollable  @input="$refs.menu.save(data.fromDate)" />
            </v-menu>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3 px-3>
            <v-menu
              ref="menu2"
              v-model="menu2"
              :return-value.sync="data.toDate"
              lazy
              transition="scale-transition"
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="data.toDate"
                :label="$lang.labels.toDate"
                prepend-icon="event"
                required
                :rules="[v => !!v || `${$lang.errors.missingToDate}`]"
                readonly
              />
              <v-date-picker color="primary" v-model="data.toDate" no-title scrollable  @input="$refs.menu2.save(data.toDate)" />
            </v-menu>
          </v-flex>
          <v-btn :disabled="!valid" color="primary" class="mx-3" @click="serachResources()">{{$lang.labels.search}}</v-btn>
        </v-layout>
      </v-form>
      <v-data-table
        v-if="show"
        :headers="headers"
        :items="resources"
        :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
      >
        <v-progress-linear height="6" slot="progress" color="primary" indeterminate />
        <template slot="items" slot-scope="props">
          <td>
            {{ props.item.resourceType }}
            <small class="d-block">{{ props.item.id }}</small>
          </td>
          <td>{{ props.item.resourceTrackingAction }}</td>
          <td>{{ props.item.status }}</td>
          <td>{{ props.item.fromDate ? formatDate(props.item.fromDate) : '-' }}</td>
          <td>{{ props.item.toDate ? formatDate(props.item.toDate) : '-' }}</td>
          <td v-if="props.item.closedOn">
            {{ formatDate(props.item.closedOn) }}
            <div class="d-block">{{ props.item.reasonForClosure }}</div>
          </td>
          <td v-else>-</td>
          <td v-if="props.item.data != null">
            {{ props.item.data }}
            <v-btn 
              class="mx-0" 
              flat small 
              @click="showData(props.item.data)">
              ...
            </v-btn>
          </td>
          <td v-else>-</td>
        </template>
        <v-alert slot="no-results" :value="true" type="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
    <v-dialog v-if="resourceModal" v-model="resourceModal" max-width="1200">
      <resource-modal :data="resourceData" @close="resourceModal = false"/>
    </v-dialog>
  </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';
  
  export default {
    components: {
      resourceModal: () => import('../modals/AuditModal'),
    },
    data() {
      return {
        err: '',
        success: '',
        search: '',
        show: false,
        loading: true,
        valid: false,
        companies: [],
        menu: false,
        menu2: false,
        trackingTypes: [
          { text: 'Moon License', value: 'moonlicense' },
          { text: 'WebShop Resource', value: 'webshopresource' },
          { text: 'WebSpace', value: 'webspace'},
          { text: 'Domain', value: 'domain' },
          { text: 'App Resource', value: 'appresource' },
          { text: 'WebShop Resource Add Revenue', value: 'webshopresourceaddrevenue'},
        ],
        data: {
          companyId: null,
          fromDate: DateTime.local().startOf('month').toFormat('yyyy-MM-dd'),
          toDate: DateTime.local().toFormat('yyyy-MM-dd'),
          resourceTrackingTypes: ['moonlicense', 'webshopresource', 'webspace', 'domain', 'appresource', 'webshopresourceaddrevenue'],
        },
        companyLoading: true,
        headers: [
          { text: this.$lang.header.resourceType, value: 'resourceType', align: 'left' },
          { text: this.$lang.header.trackingAction, value: 'resourceTrackingAction', align: 'left' },
          { text: this.$lang.labels.status, value: 'status', align: 'left' },
          { text: this.$lang.labels.fromDate, value: 'fromDate', align: 'left' },
          { text: this.$lang.labels.toDate, value: 'toDate', align: 'left' },
          { text: this.$lang.header.closedReason, value: 'closedOn', align: 'left', sortable: false },
          { text: this.$lang.labels.data, value: 'data', align: 'left', sortable: false },
        ],
        resources: [],
        resourceData: null,
        resourceModal: false,
      };
    },
    computed: {
      mappedCompanies() {
        return this.companies.map(company => ({
          text: `${company.name} (${company.companyStatus})`,
          value: company.id,
        }));
      },
    },
    methods: {
      showData(data) {
        this.resourceData = data;
        this.resourceModal = true;
      },
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd HH:mm');
      },
      init() {
        return new Promise((resolve) => {
            this.$http.get('company')
            .then((res) => {
              resolve()
              this.companyLoading = false;
              if (res.body.status === 'Success') {
                this.companies = res.body.companies;
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              resolve()
              this.companyLoading = false;
              this.err = err.body.statusText || err.body.message;
            });
        });
      },
      serachResources() {
        this.show = true;
        this.$http.post('resourcetracking/getall', this.data)
        .then((res) => {
          if (res.body.status === 'Success') {
            const resources = [];
            if (res.body.moonLicenses.length > 0) {
              res.body.moonLicenses.map((data) => {
                resources.push(data);
              });
            }
            if (res.body.webShopResources.length > 0) {
              res.body.webShopResources.map((data) => {
                resources.push(data);
              });
            }
            if (res.body.wsrRevenueEntries.length > 0) {
              res.body.wsrRevenueEntries.map((data) => {
                resources.push(data);
              });
            }
            if (res.body.webSpaces.length > 0) {
              res.body.webSpaces.map((data) => {
                resources.push(data);
              });
            }
            if (res.body.domains.length > 0) {
              res.body.domains.map((data) => {
                resources.push(data);
              });
            }
            if (res.body.appResources.length > 0) {
              res.body.appResources.map((data) => {
                resources.push(data);
              });
            }
            resources.map((resource) => {
              if (resource.data) {
                let data = JSON.stringify(resource.data);
                return data = data.slice(0, 63);   
              }
            });
            return this.resources = resources;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
      },
    },
    created() {
      this.init()
        .then(() => {
          const edit = this.$cookie.get('companyedit');
          if (edit) this.data.companyId = edit;
        });
    },
  };
</script>


// WEBPACK FOOTER //
// ResourceTracking.vue?5fef71ee